import { useState } from "react";
import { ChevronRight, Terminal } from "lucide-react";
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from "../ui/collapsible";

export function CommandsSection({ section, index }) {
  const [open, setOpen] = useState(false);
  return (
    <Collapsible open={open} onOpenChange={setOpen} className="my-3 rounded-lg border border-border overflow-hidden">
      <CollapsibleTrigger
        data-testid={`typed-section-commands-toggle-${index}`}
        className="flex w-full items-center gap-2 px-3 py-2 bg-muted/50 text-sm font-mono hover:bg-muted transition-colors"
      >
        <Terminal className="h-3.5 w-3.5" />
        <span>{section.title || "Comandos de referencia"}</span>
        <ChevronRight className={`h-3.5 w-3.5 ml-auto transition-transform ${open ? "rotate-90" : ""}`} />
      </CollapsibleTrigger>
      <CollapsibleContent className="bg-zinc-950 text-zinc-100 px-3 py-2 font-mono text-xs space-y-1">
        {section.commands.map((cmd, i) => (
          <div key={i}>
            <span className="text-emerald-400">$</span> {cmd}
          </div>
        ))}
      </CollapsibleContent>
    </Collapsible>
  );
}
